export default { 
    getGenderList: (state) => state.genderList 
}